export default "__VITE_ASSET__SkE3t23w__"